export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'flaticon-dashboard'
    },
    {
      name: 'Users',
      url: '/users',
      icon: 'flaticon-user-silhouette'
    },
    {
      name: 'Events',
      url: '/events'
    },
    {
      name: 'Configuration',
      url: '/configuration', 
    },
    
    {
      name: 'BlockFeatures',
      url: '/blockfeatures'
    },

    {
      name: 'Searches',
      url: '/searches',
    },

  ],
};
